import * as MyKeysApi from './index';
import { mapGetUserDetailsDto } from './mappings';
import { MyKeysPromise } from './interfaces';
import { UserInfo } from '../../../models';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const getUserDetails = (email: string): MyKeysPromise<UserInfo> => {
  const body = { email };
  Logger.info(['POST: getUserDetails', body], LogArea.Api);
  return MyKeysApi.post('LoginServer/GetUserDetails', body, true)
    .then((res) => mapGetUserDetailsDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const createUser = (email: string): MyKeysPromise<UserInfo> => {
  const body = { email };
  Logger.info(['POST: CreateUserByDefaultCustomer', body], LogArea.Api);
  return MyKeysApi.post('LoginServer/CreateUserByDefaultCustomer', body, true)
    .then((res) => mapGetUserDetailsDto(res.data))
    .catch(MyKeysApi.parseError);
};
